"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var ComponentTitleStyle_1 = require("../typography/ComponentTitleStyle");
var Icon_1 = __importDefault(require("../icon/Icon"));
var Elevation_1 = require("../../common/enums/Elevation");
var ExpansionState;
(function (ExpansionState) {
    ExpansionState["CLOSED"] = "closed";
    ExpansionState["OPEN"] = "open";
})(ExpansionState || (ExpansionState = {}));
var ExpansionPanel = function (props) {
    var children = props.children, classes = props.classes, collapsePadding = props.collapsePadding, disableMaxHeight = props.disableMaxHeight, elevation = props.elevation, icon = props.icon, index = props.index, onClick = props.onClick, onToggle = props.onToggle, open = props.open, staticPadding = props.staticPadding, subtitle = props.subtitle, title = props.title, titleStyle = props.titleStyle, whiteOnWhite = props.whiteOnWhite, otherProps = __rest(props, ["children", "classes", "collapsePadding", "disableMaxHeight", "elevation", "icon", "index", "onClick", "onToggle", "open", "staticPadding", "subtitle", "title", "titleStyle", "whiteOnWhite"]);
    var _a = react_1.useState(open ? ExpansionState.OPEN : ExpansionState.CLOSED), expansionState = _a[0], setExpansionState = _a[1];
    var targetBodyRef = react_1.useRef(null);
    var _b = react_1.useState(), maxHeight = _b[0], setMaxHeight = _b[1];
    var componentClassNames = getComponentClassNames(elevation, staticPadding, whiteOnWhite, classes, expansionState);
    react_1.useEffect(function () {
        setMaxHeight(expansionState === ExpansionState.OPEN ? targetBodyRef.current.scrollHeight : 0);
    }, [children, expansionState]);
    react_1.useEffect(function () {
        setExpansionState(open ? ExpansionState.OPEN : ExpansionState.CLOSED);
    }, [open]);
    react_1.useEffect(function () {
        var eventName = 'resize';
        var handleResize = function () {
            (expansionState === ExpansionState.OPEN) && setMaxHeight(targetBodyRef.current.scrollHeight);
        };
        typeof window !== 'undefined' && window.addEventListener(eventName, handleResize);
        return function () { return typeof window !== 'undefined' && window.removeEventListener(eventName, handleResize); };
    }, [expansionState]);
    var handleClick = function () {
        handleToggle();
        typeof onClick === 'function' && onClick(expansionState !== ExpansionState.OPEN, index);
    };
    var handleToggle = function () {
        typeof onToggle === 'function' && onToggle(expansionState !== ExpansionState.OPEN, index);
        var state = expansionState === ExpansionState.OPEN ?
            ExpansionState.CLOSED :
            ExpansionState.OPEN;
        setExpansionState(state);
    };
    return (react_1.default.createElement("div", __assign({}, otherProps, { className: componentClassNames }),
        react_1.default.createElement("div", { "aria-expanded": expansionState === ExpansionState.OPEN, className: "fds-expansion-panel-trigger", onClick: handleClick, role: "button" },
            icon && react_1.default.createElement("div", { className: "fds-expansion-panel-icon" }, icon),
            react_1.default.createElement("div", { className: "fds-expansion-panel-header" },
                react_1.default.createElement("div", { className: "fds-expansion-panel-header-body" },
                    react_1.default.createElement("h3", { className: getTitleClassNames(titleStyle) }, title),
                    subtitle && (react_1.default.createElement("div", { className: "fds-expansion-panel-subtitle" },
                        react_1.default.createElement("p", null, subtitle))))),
            react_1.default.createElement("div", { className: "fds-expansion-panel-toggle-icon" },
                react_1.default.createElement(Icon_1.default, { name: "keyboard-arrow-down" }))),
        react_1.default.createElement("div", { "aria-hidden": expansionState === ExpansionState.CLOSED, className: "fds-expansion-panel-target", style: disableMaxHeight ? {} : { maxHeight: maxHeight } },
            react_1.default.createElement("div", { className: getBodyClasses(collapsePadding), ref: targetBodyRef }, children))));
};
ExpansionPanel.defaultProps = {};
var getComponentClassNames = function (elevation, staticPadding, whiteOnWhite, classes, expansionState) {
    var _a;
    return classnames_1.default('fds-expansion-panel', (_a = {},
        _a["elevation-" + elevation] = elevation && elevation !== Elevation_1.DEFAULT_ELEVATION,
        _a['fds-expansion-panel-open'] = expansionState === ExpansionState.OPEN,
        _a['fds-expansion-panel-closed'] = expansionState === ExpansionState.CLOSED,
        _a['fds-expansion-panel-static-padding'] = staticPadding,
        _a['fds-white-on-white'] = whiteOnWhite,
        _a), classes);
};
var getTitleClassNames = function (titleStyle) {
    var _a;
    return classnames_1.default('fds-expansion-panel-title', (_a = {},
        _a["fds-title-type-" + titleStyle] = titleStyle && titleStyle !== ComponentTitleStyle_1.DEFAULT_COMPONENT_TITLE_STYLE,
        _a));
};
var getBodyClasses = function (collapsePadding) {
    return classnames_1.default('fds-expansion-panel-body', {
        'collapse-padding': collapsePadding
    });
};
exports.default = ExpansionPanel;
